type Props = {
    className?: string;
    class?: string;
};

const Accordion = ({ children, className, ...rest }: React.PropsWithChildren<Props>) => (
    <ul className={className} {...rest}>
        {children}
    </ul>
);

export default Accordion;
